import { Observable } from 'rxjs'
import { TrainingModel } from '../models/training-model'

export abstract class TrainingStateGateway {
    // abstract GetUserTrainingDetails(planyear: string, orgid: string, userName: string): Observable<TrainingModel[]>
    abstract GetUserTrainingDetails(userProfileID: number, planyear: number): Observable<TrainingModel[]>
}
